// src/config/monitoredStatuses.js

export const MONITORED_STATUSES = {
  VERIFICAR: {
    label: "Verificar",
    titulo_modal: "Por que este pedido foi para Verificar?",
  },
  FALHA_BANCA: {
    label: "Falha Banca",
    titulo_modal: "Motivo da reprovação na verificação de qualidade",
  },
};

/**
 * Checks if a status is being monitored for Quality Control / deviation causes.
 * @param {string} status 
 * @returns {boolean}
 */
export const isMonitored = (status) => !!MONITORED_STATUSES[status];
